<template>
  <div class="menu">
    <nav>
      <router-link :to="{ name: 'Deals'}" class="nav-item">Сделки</router-link>
      <router-link :to="{ name: 'Contacts'}" class="nav-item">Контакты</router-link>
      <router-link :to="{ name: 'Companies'}" class="nav-item">Компании</router-link>
      <router-link :to="{ name: 'TasksKanban'}" class="nav-item">Задачи</router-link>
      <!--<router-link :to="{ name: 'Tasks'}" class="nav-item">Задачи</router-link>-->
      <router-link :to="{ name: 'Users'}" class="nav-item">Пользователи</router-link>
      <router-link :to="{ name: 'TelegramBot'}" class="nav-item">Telegram <b-icon v-if="$store.getters.newTlgMessages" icon="exclamation-circle-fill" variant="danger"></b-icon></router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Menu'
}
</script>

<style lang="scss" scoped>
.menu {
  min-height: 100vh;
  width: 150px;
  padding: 25px;
  border-right: 1px solid #ccc;
  position: sticky;
  background-color: #f5f5f5;

  a {
    color: #333;
  }

  a:hover {
    color: #666;
    text-decoration: none;
  }
}

nav {
  display: flex;
  flex-wrap: wrap;

  .nav-item {
    margin: 10px 0;
  }

  .router-link-active {
    font-weight: bold;
  }
}
</style>
